import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import Report from "./Pages/Report";
import { useSelector } from "react-redux";
import { stateUser } from "./Features/userSlice";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Diet from "./Pages/Diet";
import Workout from "./Pages/Workout";
import ResetPassword from "./Pages/ResetPassword";

function App() {
  const user = useSelector(stateUser);
  const workout = useSelector((state) => state.workout.workout)
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.isLogin) {
      navigate("/login");
    }else if(workout) {
      navigate("/workout")
    }
  }, [user, workout]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/" element={<Home />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/diet" element={<Diet />} />
      <Route path="/workout" element={<Workout />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/report" element={<Report />} />
    </Routes>
  );
}

export default App;
